<h2 class="user-title">Notificações</h2>
<div class="no-results-wrapper">
    Não há notificações
</div>